import { client } from './client';
import interceptors from './interceptors';
import qs from 'qs';


client.interceptors.request.use(interceptors.auth, interceptors.onError);

function detailMember(params) {
	return client.get('/tunnel/api/member/transaction/detail', {
		params: params,
	});
}

function detailPublic(params) {
	return client.get('/tunnel/api/public/transaction/detail', {
		params: params,
	});
}

function Member(params) {
	return client.get('/tunnel/api/member/transaction/data', {
		params: params,
	});
}

function transferMember(params) {
	return client.post('/tunnel/api/member/transaction/confirmationtransfer', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded',
		},
	});
}


function transferPublic(params) {
	return client.post('/tunnel/api/public/transaction/confirmationtransfer', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function penerimaanPublic(params) {
	return client.post('/tunnel/api/public/transaction/confirmationdone', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function penerimaanMember(params) {
	return client.post('/tunnel/api/member/transaction/confirmationdone', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function cancelMember(params) {
	return client.post('/tunnel/api/member/transaction/cancel', qs.stringify(params), {
		header: {
			'Content-Type': 'application/x-www-form-urlencoded'
		},
	});
}

function pickupMember(params) {
    return client.post('/tunnel/api/member/transaction/shippingpickup', qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function pickupPublic(params) {
    return client.post('/tunnel/api/public/transaction/shippingPickup', qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function shippingMember(params) {
    return client.post('/tunnel/api/member/transaction/shippingCourier', qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function shippingPublic(params) {
    return client.post('/tunnel/api/public/transaction/shippingCourier', qs.stringify(params), {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    });
}

function getOngkir(params) {
    return client.get('/tunnel/api/public/transaction/ongkir', {
        params: params,
    });
}

function itemRegister() {
	return client.get('/tunnel/api/public/registration/register_item');
}

function registerArea(params) {
	return client.get('/tunnel/api/public/registration/registration_area', {
		params: params,
	});
}

export default {
	Member,
	detailPublic,
	detailMember,
	transferMember,
	transferPublic,
	shippingMember,
	shippingPublic,
	pickupMember,
	pickupPublic,
	cancelMember,
	penerimaanPublic,
	penerimaanMember,
	getOngkir,
	itemRegister,
	registerArea
};